import styled, { StyledProps } from 'styled-components'
import { EModActive, IModActive } from '@ucheba/utils/helpers/styles/mod.types'
import { sm } from '@ucheba/utils/helpers/styles/mixins'

const ScrollItemsWrapperInner = styled.div<StyledProps<IModActive>>`
  ${sm.mod(EModActive.true)`
    overflow-y: auto;
    -webkit-overflow-scrolling: auto;
    position: relative;
  `};
`

const ScrollItemsWrapper = styled.div<StyledProps<IModActive>>`
  ${sm.mod(EModActive.true)`
    position: relative;

    &:after {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 35px;
      pointer-events: none;
      background: linear-gradient(0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 0) 100%);
    }
  `};
`

export default { ScrollItemsWrapper, ScrollItemsWrapperInner }
